import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editButtonLabel: {
		id: 'servicedesk-customer-service-custom-details.common.field.edit-button-label',
		defaultMessage: '{label}, {value}, select to edit',
		description:
			'Aria label for the detail field inline edit. The label is the name of the field and the value is the current value of the field. Upon activation the value can be edited.',
	},
	noValue: {
		id: 'servicedesk-customer-service-custom-details.common.field.no-value',
		defaultMessage: 'no value entered',
		description:
			'String for the value variable of the editButtonLabel message when there is no value for the field',
	},
});
